import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { IonContent, IonPage } from "@ionic/react";
import { Row, Col, Form, Image } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import { useTranslation } from "react-i18next";
import metaData from "../data/metaData";
import log from "../utils/log";
import c from "../utils/common";
import _ from "lodash";

//
import Header from "../components/GetStarted/Header";
import UploadButton from "../components/General/UploadBtn";
import SectionHeader from "../components/GetStarted/SectionHeader";
import Name from "../components/General/Name";
import AddressForm from "../components/Address/Form";

//State
import useRequestStore from "../states/useRequest";
import useAuthStore from "../states/useAuth";

const Uploader = ({ br, onFinish }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: "2rem" }}>
      <Col>
        {br ? (
          <Image
            width={"12vw"}
            height={"15vw"}
            style={{ objectFit: "contain" }}
            src={metaData.blobPreURL + "clientUpload-" + br + ".jpeg" + metaData.blobPostURL}
          />
        ) : (
          <Row
            justify="center"
            align="middle"
            style={{
              width: "12vw",
              height: "15vw",
              background: "var(--ion-color-step-50)",
              cursor: "pointer",
            }}
          >
            <UploadOutlined style={{ fontSize: "1.25rem" }} />
          </Row>
        )}
      </Col>
      <Col>
        <UploadButton
          onFinish={onFinish} // Pass onFinish to handle the final file name
          buttonLabel={br ? t("newVendor.ChooseAnother") : "Choose photo"} // Dynamic label
          aspect={undefined}
        />
      </Col>
    </Row>
  );
};

const GetStartedPage = () => {
  const history = useHistory();
  const { user } = useAuthStore();
  const { newCompany, updateNewCompany } = useRequestStore();

  const [companyForm] = Form.useForm();
  const [company, setCompany] = useState(newCompany);

  const readOnly = useMemo(() => {
    log.debug(user);
    let { shop: canUpdate } = user?.permission || {};
    log.debug(canUpdate);
    return !canUpdate;
    // return false;
  }, [user]);

  const handleNextStep = async () => {
    try {
      await companyForm.validateFields();
    } catch (error) {
      log.error(error);
      return;
    }

    let { name, br, address } = company;

    //validate br
    if (!br) {
      return c.message({ type: "error", content: "BR is required" });
    }

    let parsedCompany = {
      name: name?.trim(),
      br,
      address: address ? { ...address, street: address.street?.trim() } : undefined,
    };

    log.debug(parsedCompany);

    updateNewCompany("whole", parsedCompany);
    history.push({ pathname: "/get-started/shop/1" });
  };

  const updateCompanyData = (newData) => {
    log.debug(newData);
    setCompany((prev) => {
      // Create a copy of the previous shop data
      let updated = _.merge({}, prev, newData);
      return updated;
    });
  };

  return (
    <IonPage>
      <IonContent>
        <Header
          step={1}
          onNext={() => {
            handleNextStep();
          }}
        />
        <Row justify="center" style={{ width: "100%" }}>
          <Row
            style={{ maxWidth: "50vw", padding: "20px" }}
            onClick={() => {
              log.debug(user);
            }}
          >
            <h1 style={{ width: "100%", fontSize: "32px", fontWeight: "bold" }}>Welcome! Let's create your profile</h1>
            <p style={{ width: "100%", color: "#666", marginBottom: "1.25rem" }}>
              Let us get to know your business better!
            </p>
            <SectionHeader
              title="Company Name"
              description="This is for our reference and will not be displayed in the mobile app."
            />
            <Name
              state={{
                data: company?.name,
                form: companyForm,
                rules: [{ required: true, message: "required" }],
                onChange: updateCompanyData,
              }}
              readOnly={readOnly}
              maxLength={60}
              showCount
            />
            <SectionHeader title="Business Registration" />
            <Form.Item>
              <Uploader
                br={company?.br}
                onFinish={(url) => {
                  updateCompanyData({ br: url });
                }}
              />
            </Form.Item>
            <SectionHeader title="Address" description={readOnly ? null : "Where is your company located?"} />
            <AddressForm
              state={{ data: company?.address, form: companyForm, onChange: updateCompanyData }}
              readOnly={readOnly}
            />
          </Row>
        </Row>

        <Row style={{ height: "5rem" }}></Row>
      </IonContent>
    </IonPage>
  );
};

export default GetStartedPage;
